module.exports = __webpack_public_path__ + "static/media/zurich-seguros.eb03c597.svg";